"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var imageSources = [{
  media: '(min-width: 300px)',
  srcsetList: [{
    template: '180x240_standard'
  }, {
    template: '180x240_retinax2',
    scale: '1.5x'
  }, {
    template: '180x240_retinax2',
    scale: '2x'
  }]
}];
var _default = exports["default"] = imageSources;